// 챗별 답변 모델(CHATS.AI_MODEL) 선택지 — 서버 SERVER/chat-core/util/aiModel.js ANSWER_MODELS 의 미러(바꾸면 같이 고칠 것).
// 봇 대사를 쓰는 LLM(첫 안내·유도 턴·자유 답변)만 바뀐다. 라우팅·목표 판정·평가문 모델은 서버가 따로 정한다.
// 비우면("") 서버 전역 설정(CHAT_SETTINGS.AI_API_MODE). 서버는 목록 밖 값을 저장·실행 모두에서 전역으로 돌린다.
export const ANSWER_MODELS = [
	{ name: "gpt-4o-mini", label: "gpt-4o-mini — 빠르고 싸다" },
	{ name: "gpt-4.1-mini", label: "gpt-4.1-mini — 설정한 말 규칙을 더 잘 지킨다(약 2.7배)" },
	{ name: "gpt-4.1", label: "gpt-4.1 — 가장 정확하다(약 13배)" },
];
